<template>
  <div class="animated fadeIn">
    <b-card v-if="showList">
      <div slot="header">Maintenance Manual/Guidence 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter" class="mb-1">
        <b-col lg="6">
              <b-row>
                <b-col lg="8">
                    <b-input-group >
                      <b-input-group-prepend><label>Asset Category</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.assetCatgId" :plain="true" :options="categories"></b-form-select>
                    </b-input-group>
                  </b-col>
                <b-col  lg="4">
                    <b-input-group >
                      <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.assetModel" placeholder="Model/Type/Series"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>     
        </b-col>
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><span class="pt-2">Component/Part &nbsp;</span></b-input-group-prepend>
              <b-form-input v-model="tblData.assetPart" placeholder="Body/Engine/Electronic"></b-form-input>
              <b-input-group-append>
                  <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(costEstimate)="data">
          <!-- <b-row v-if="(data.item.costEstimate)">
            <b-col cols="3">
                {{data.item.matauang}}
            </b-col>
            <b-col cols="9">
              {{data.item.costEstimate|numFormat}}
            </b-col>
          </b-row> -->
          <span v-if="(data.item.costEstimate)">{{data.item.matauang}} &nbsp;&nbsp;&nbsp;{{data.item.costEstimate|numFormat}}</span>
        </template>
        <template v-slot:cell(costEstUpdate)="data">
          <span v-if="(data.item.costEstimate)">{{data.item.costEstUpdate| moment('D-MMM-YY')}}</span>
        </template>
        <template v-slot:cell(intervalCal)="data">
          {{data.item.intervalCal | numFormat}} DAYS <br>
          <p v-if="(data.item.intervalUom)">{{data.item.intervalUom |numFormat }} {{data.item.intervalUomCode}}</p>
        </template>
      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
          </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure about doing this ?</p>
      </b-modal>
  </div>
</template>

<style lang="scss">
    .list-of-fixedasset {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: 120px;
        }
      }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import mm from "../../apis/maintenguide";
toastr.init();

export default {
  components: { Loading},
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      showFilter:false,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'assetCatgName',
        sortDesc: false,
      },
      model:{inspMstrKey:''},
      categories:[],
      tblFields:[
          {
            key: "referDoc",
            label: "Doc. No.",
            thStyle: "width:140px",
            sortable: true
          },
          {
            key: "inspectName",
            label: "Maintenance/Inspection Name",
          },
          {
            key: "intervalCal",
            label: "Repetitif Interval",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "assetCatgName",
            label: "Category/Group Assets",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "assetModel",
            label: "Model/Type",
            thStyle: "width:120px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "assetPart",
            label: "Part/Component",
            thStyle: "width:120px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "costEstimate",
            label: "Estimate Cost",
            thClass: "text-right",
            tdClass: "text-right",
            thStyle: "width:140px",
            sortable: true
          },
          {
            key: "costEstUpdate",
            thStyle: "width:100px",
            label: "Cost Update",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "createby",
            thStyle: "width:80px",
            label: "Create By",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
        ],
      categories:[]
    };

  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    catgid() {
      return this.tblData.catgid;
    },
  },
  watch:{
    catgid: function(newval){
      const catg = this.categories.find(c => c.value == newval)
      if (catg) {
        this.tblData.category=catg.text;
      }
    }
  },
  created: async function(){
      const [a] = await Promise.all([mm.category()]) ;
        this.categories = a.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.mmList) {
            this.tblData[key] = filter.mmList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.showFilter=filtered;
          delete filter.mmList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.isLoading=true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await mm.list(this.tblData);      
      this.isLoading=false;
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table)  this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.assetCatgId= '';
        this.tblData.assetCatgName= '';
        this.tblData.assetModel=  '';
    },
    saveFilter() {
      const keys = ['catgid', 'category', 'catgname', 'nomorpo', 'outstand', 'asetid', 'asdesc', 'asmodel','asserial', 'asuser', 'aslocat', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal'];
      let filtered = false;
      const mmList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              mmList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          mmList.page=this.tblData.page;
          mmList.limit=this.tblData.limit;
          mmList.sortBy=this.tblData.sortBy;
          mmList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.mmList=mmList;
          this.$store.commit("filter", filter);
      }
    },    

    add: function(data) {
        this.saveFilter()
          router.push({name :'fixedasset.maintmanualfrm'});
    },
    edit: function() {
      if (this.model.inspMstrKey) {
        this.saveFilter()
        router.push({name :'fixedasset.maintmanualfrm', params: { inspMstrKey: this.model.inspMstrKey}});
      } else {
            toastr.warn('Please select a row that want to be Edit!');
      }
    },
    save: function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              mm.save(this.frmdata);
              this.closeFrm();    
              setTimeout(() => {
                  this.refresh();              
              }, 500);       

            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm() {
        if (this.model.inspMstrKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      await mm.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.model.inspMstrKey==record.inspMstrKey) {
        console.log('model row click: ', this.model);
        this.edit();
      } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            this.tblData.expMode='acc';
            const response = await mm.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
